module.exports = __webpack_public_path__ + "static/media/deptimage1.f84b7cc2.JPG";